<div  class="container mt-5">
  
    <div class="row" >
        <!-- Shopping Cart Items -->
     
        <div  class="col-lg-8">
            <h3>Your Orders</h3>

            <!-- Cart Item 1 -->
            <div class="cart-item d-flex justify-content-between" *ngFor="let product of cartOrder"> 
                <div class="d-flex">
                    <img src={{product.productImage}} alt="Product" class="product-img me-3">
                    <div>
                        <h5>{{product.productName}}</h5>
                        <p class="text-muted">Description of the product.</p>
                        <input type="number" class="form-control w-25" value="1">
                    </div>
                </div>
                <!-- <div class="d-flex flex-column justify-content-between">
                    <span>{{product.productPrice}}</span>
                    <button class="btn btn-sm removeButton">Remove</button>
                </div> -->
            </div>

            <!-- Cart Item 2 -->
            <!-- <div class="cart-item d-flex justify-content-between">
                <div class="d-flex">
                    <img src="https://via.placeholder.com/100" alt="Product" class="product-img me-3">
                    <div>
                        <h5>Product Name 2</h5>
                        <p class="text-muted">Another product description.</p>
                        <input type="number" class="form-control w-25" value="2">
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-between">
                    <span>$19.99</span>
                    <button class="btn btn-sm removeButton">Remove</button>
                </div>
            </div> -->

        </div>

        <!-- Cart Summary -->
        <!-- <div class="col-lg-4 cartSummary">
            <div class="cart-summary">
                <h4>Cart Summary</h4>
                <ul class="list-unstyled">
                    <li class="d-flex justify-content-between">
                        <span>Subtotal:</span>
                        <span>$45.98</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span>Shipping:</span>
                        <span>$5.00</span>
                    </li>
                    <li class="d-flex justify-content-between">
                        <span class="total-price">Total:</span>
                        <span class="total-price">$50.98</span>
                    </li>
                </ul>
                <button class="btn btn-checkout w-100">Proceed to Checkout</button>
              
            </div>
        </div> -->
    </div>
 
</div>
